function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class NotificationConfigsEntity {
  constructor({
    ..._data
  }) {
    _defineProperty(this, "mapToSnakeCase", data => {
      return {
        pk: data.pk,
        state_management: data.stateManagement,
        notification_template: data.notificationTemplate,
        notification_type: data.notificationType,
        delivery_type: data.deliveryType,
        role_pks: data.rolePks,
        follow_up_notification: +data.followUpNotification,
        follow_up_after: +data.followUpAfter,
        is_recurring_follow_up: data.isRecurringFollowUp,
        recurring_count: +data.recurringCount,
        extra_data: data.extraData.attributes?.length ? data.extraData : {
          attributes: []
        },
        is_active: data.isActive,
        is_breached: data.isBreached
      };
    });
    if (Object.keys(_data).length) {
      this.pk = _data.pk;
      this.stateManagement = _data.state_management;
      this.notificationTemplate = _data.notification_template;
      this.notificationType = _data.notification_type;
      this.deliveryType = _data.delivery_type;
      this.rolePks = _data.role_pks;
      this.followUpNotification = _data.follow_up_notification;
      this.followUpAfter = _data.follow_up_after;
      this.isRecurringFollowUp = _data.is_recurring_follow_up;
      this.recurringCount = _data.recurring_count;
      this.extraData = _data.extra_data.users?.length ? _data.extra_data : {
        users: []
      };
      this.isActive = _data.is_active;
      this.isBreached = _data.is_breached;
    }
  }
}
export default NotificationConfigsEntity;